import type { MainGenderBlockContent } from '@components/public/main';
import type { PageMeta } from '@components/types';
import type { TranslationFunctions } from '@i18n/i18n-types';
import { detectLocale } from '@i18n/i18n-util';
import { APP_NAME } from '@shared/constants';
import { COMPETITOR_NAME } from '@shared/constants/alternative';
import { Competitor } from '@shared/route-types';

import type { AlternativeInfoBlockContent, DirtyrouletteInfoBlockContent } from './info-block/types';

const IMG_DIR = '/images/landings/alternative';

export function getAlternativeLogo($LL: TranslationFunctions, competitor: Competitor): { src: string; alt: string } {
    const competitorName = COMPETITOR_NAME[competitor];
    return {
        src: `${IMG_DIR}/${competitor}-alternative-flirtify.svg`,
        alt: $LL.alternative.common.logoAlt({ appName: APP_NAME, competitorName }),
    };
}

export function getAlternativeContent($LL: TranslationFunctions, competitor: Competitor): {
    meta: PageMeta;
    genderBlockContent: MainGenderBlockContent;
    infoBlockContent: AlternativeInfoBlockContent | DirtyrouletteInfoBlockContent;
} {
    const a = $LL.alternative;
    const m = $LL.main;
    const competitorName = COMPETITOR_NAME[competitor];
    const isDirtyrouletteContent = isCustomDirtyrouletteContent(competitor);

    return {
        meta: {
            title: a.common.metaTitle({ appName: APP_NAME, competitorName }),
            description: a.common.metaDescription({ appName: APP_NAME, competitorName }),
            ogImage: `${IMG_DIR}/${competitor}-random-chat-alternative-18.png`,
        },
        genderBlockContent: {
            title: a.common.title({ competitorName }),
            subtitle: a[competitor].subtitle({ competitorName, appName: APP_NAME }),
            buttonFemaleLabel: m.buttonFemaleLabel(),
            buttonMaleLabel: m.buttonMaleLabel(),
            buttonStartLabel: $LL.main.buttonStartLabel(),
        },
        infoBlockContent: isDirtyrouletteContent ?
            getDirtyrouletteInfoBlockContent($LL, competitor)
            : {
                title: a.common.title({ competitorName }),
                subtitle: a[competitor].subtitle({ appName: APP_NAME, competitorName }),
                best: {
                    preamble: a[competitor].best.preamble({ appName: APP_NAME, competitorName }),
                    title: a.common.best.title({ appName: APP_NAME, competitorName }),
                    text: a[competitor].best.text({ appName: APP_NAME, competitorName }),
                    imgAlt: a.common.best.imgAlt({ competitorName }),
                    imgSrc: `${IMG_DIR}/best-${competitor}-alternative.png`,
                },
                why: {
                    title: a.common.why.title({ appName: APP_NAME, competitorName }),
                    text: a[competitor].why.text({ appName: APP_NAME, competitorName }),
                    article1: {
                        title: a[competitor].why.article1.title(),
                        text: a[competitor].why.article1.text({ appName: APP_NAME, competitorName }),
                        imgAlt: a.common.why.article1.imgAlt({ competitorName }),
                        imgSrc: `${IMG_DIR}/${competitor}-random-chat-alternative-18.png`,
                    },
                    article2: {
                        title: a[competitor].why.article2.title(),
                        text: a[competitor].why.article2.text({ appName: APP_NAME, competitorName }),
                        imgAlt: a.common.why.article2.imgAlt({ competitorName }),
                        imgSrc: `${IMG_DIR}/${competitor}-text-chat-alternative.png`,
                    },
                    article3: {
                        title: a[competitor].why.article3.title(),
                        text: a[competitor].why.article3.text({ appName: APP_NAME, competitorName }),
                        imgAlt: a.common.why.article3.imgAlt({ competitorName }),
                        imgSrc: `${IMG_DIR}/${competitor}-alternative-site.png`,
                    },
                    article4: {
                        title: a[competitor].why.article4.title(),
                        text: a[competitor].why.article4.text({ appName: APP_NAME, competitorName }),
                        imgAlt: a.common.why.article4.imgAlt({ appName: APP_NAME, competitorName }),
                        imgSrc: `${IMG_DIR}/flirtify-alternative-to-${competitor}.png`,
                    },
                },
                try: {
                    title: a.common.try.title({ competitorName }),
                    text: a[competitor].try.text({ appName: APP_NAME, competitorName }),
                    buttonLabel: m.sec4.buttonLabel(),
                },
                comparisons: {
                    title: a.common.comparisons({ appName: APP_NAME }),
                },
            },
    };
}

export function isCustomDirtyrouletteContent(competitor: Competitor): boolean {
    return competitor === Competitor.Dirtyroulette && (detectLocale() === 'en');
}

/* eslint-disable max-len */
function getDirtyrouletteInfoBlockContent(
    $LL: TranslationFunctions, competitor: Competitor): DirtyrouletteInfoBlockContent {
    const a = $LL.alternative;
    const m = $LL.main;
    const competitorName = COMPETITOR_NAME[competitor];
    return {
        title: a.common.title({ competitorName }),
        subtitle: a[competitor].subtitle({ appName: APP_NAME, competitorName }),
        intro: {
            title: 'Dirtyroulette: Random Chat Roulette',
            text: 'Dirtyroulette is an adult-oriented video chat platform that offers spontaneous webcam conversations with strangers. However, many users are looking for alternatives that offer stronger moderation, real interactions, and enhanced privacy. Flirtify delivers just that - a safer, more engaging environment that emphasizes real, authentic connections.',
        },
        best: {
            preamble: a[competitor].best.preamble({ appName: APP_NAME, competitorName }),
            title: 'Best Dirtyroulette Alternative - Flirtify',
            text: 'As the best Dirtyroulette alternative, Flirtify connects you exclusively with real people who are looking for authentic connections. Say goodbye to bots and inappropriate content - enjoy real human interaction in a safe space built on anonymity and consent. Our carefully designed features ensure dirty chats with women in a respectful environment.',
            imgAlt: a.common.best.imgAlt({ competitorName }),
            imgSrc: `${IMG_DIR}/best-${competitor}-alternative.png`,
        },
        why: {
            title: a.common.why.title({ appName: APP_NAME, competitorName }),
            text: 'Flirtify is the best Dirtyroulette chat alternative because it stands out as the premier opposite-sex video chat platform with distinct advantages over Dirty Roulette. Our one-on-one format allows for deeper cam conversations as you connect with interesting women from all over the world.',
            article1: {
                title: a[competitor].why.article1.title(),
                text: 'Our sophisticated matching system connects you only with real girls looking for private video chat. Our 18+ random chat alternative to Dirtyroulette significantly improves matching accuracy, connecting men with women more reliably than many other platforms. This eliminates a common frustration and creates a better environment for opposite-sex hookups. No more wasted time with bots or uninterested matches.Our advanced location filters allow you to connect with girls from specific countries or regions, so you can practice a new language, learn about different cultures, or simply chat with local women. Whether you\'re looking to meet someone from India, Portugal, Romania, or any of the 100+ countries we serve, Flirtify puts the world at your fingertips. Take your conversations wherever you want to go - make friends, gain new perspectives, and enjoy real connections. We elevate the basic Dirtyroulette chat concept with superior quality control and more meaningful exchanges.',
                text2: 'Unlike other sites, where you may encounter the frustrating "90% guys" problem, Flirtify ensures that you only connect with women. This means less waiting and more meaningful live video chats with the opposite sex.',
                imgAlt: a.common.why.article1.imgAlt({ competitorName }),
                imgSrc: `${IMG_DIR}/${competitor}-random-chat-alternative-18.png`,
            },
            article2: {
                title: a[competitor].why.article2.title(),
                text: 'Flirtify conversations take place in a safe, moderated environment that prioritizes your anonymity and consent, making it a great Dirtyroulette text chat alternative. You maintain complete control over your dirty chat experience in a comfortable environment. Unlike typical dirty chat roulette interactions, our robust security protocols protect you from harassment and inappropriate content at all times. Our dedicated support team is available 24/7 to address any concerns or questions you may have, ensuring that your experience remains positive and safe. We take user reports seriously and take swift action against any violations of our community guidelines.',
                text2: 'For deeper connections, our secure private chat rooms provide a confidential space for one-on-one cam interaction. Request a private chat and enjoy more privacy.',
                imgAlt: a.common.why.article2.imgAlt({ competitorName }),
                imgSrc: `${IMG_DIR}/${competitor}-text-chat-alternative.png`,
            },
            article3: {
                title: 'Constant evolution',
                text: 'We are constantly improving our platform and moderation tools to provide the best possible experience. As the fastest evolving Dirtyroulette alternative, Flirtify regularly incorporates user feedback to improve features and safety measures. Join our vibrant community and discover why our members consistently report positive, rewarding interactions.',
                imgAlt: a.common.why.article3.imgAlt({ competitorName }),
                imgSrc: `${IMG_DIR}/${competitor}-alternative-site.png`,
            },
            article3_1: {
                title: 'Access Anywhere, Anytime',
                text: 'Flirtify works seamlessly across smartphones, tablets and desktops. Enjoy our mobile-friendly site wherever you go, whenever you connect. Unlike other live chat platforms, our Dirty Roulette alternative keeps you connected no matter where life takes you.',
            },
            article4: {
                title: a[competitor].why.article4.title(),
                text: 'One-on-one video chats make room for meaningful cam conversations with interesting ladies around the world. Our community of women spans over 100 countries, including the United States, India, Spain, Italy, Germany, UK, and Mexico, allowing for authentic cultural exchange and global connections. Make new friends, discover different perspectives, and enjoy authentic connections with hot girls. Video chatting creates an instant personal connection that text just can\'t match. Experience conversations that surprise, entertain and stimulate your mind on Flirtify - the sophisticated alternative to Dirty Roulette.',
                imgAlt: a.common.why.article4.imgAlt({ appName: APP_NAME, competitorName }),
                imgSrc: `${IMG_DIR}/flirtify-alternative-to-${competitor}.png`,
            },
        },
        try: {
            title: 'Try the Best Dirtyroulette Alternative Now!',
            text: 'Looking for authentic connections with random women? Our intelligent 1on1 matchmaking system connects you in private Dirtyroulette chats with real girls who are interested in meaningful conversations. Say goodbye to unmoderated chats, bots and trolls. Our safe environment lets you control every call with real girls from around the world.',
            text2: 'Enjoy flexible payment options worldwide, with more than just credit cards. Try Flirtify for free, then easily upgrade for full access.',
            buttonLabel: m.sec4.buttonLabel(),
        },
        comparisons: {
            title: a.common.comparisons({ appName: APP_NAME }),
        },
    };
}
/* eslint-enable max-len */
